export enum ActionV2 {
  CREATE = 'create',
  AUTO_CREATE = 'autoCreate',
  CUST_CREATE = 'custCreate',
  SSO_CREATE = 'ssoCreate',
}

export const ActionValues = Object.keys(ActionV2);
